import { CommonModule } from '@angular/common';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { ColDef } from '@ag-grid-community/core';
import { Component, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DwGridDataSourceService,
  FieldTypes,
  IEnumerationCellRendererParams,
} from '@digiwall/ag-grid';
import { SupplierQuoteListDto, SupplierQuoteService } from '@digiwall/goliath-documents/proxy';
import { BaseSupplierDocList } from '../../base-supplier-docs/base-supplier-doc-list';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';

@Component({
  selector: 'document-supplier-quote-list',
  templateUrl: './supplier-quote-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class SupplierQuoteListComponent extends BaseSupplierDocList<
  SupplierQuoteListDto,
  SupplierQuoteService
> {
  private _columns: ColDef[] = [
    ...this.colDefs,
    {
      field: 'supplierDeliveryModeId',
      headerName: this.localizationService.instant('GoliathCore::DeliveryMode'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.coreEnumerationTypeStore.supplierDeliveryModes,
      } as IEnumerationCellRendererParams,
    },
    {
      field: 'supplierQuoteStatusId',
      headerName: this.localizationService.instant('Doc::QuoteStatus'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.documentEnumerationTypeStore.supplierQuoteStatus,
      } as IEnumerationCellRendererParams,
    },
  ];

  get columns(): ColDef[] {
    return this._columns;
  }

  constructor(
    protected supplierQuoteService: SupplierQuoteService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      supplierQuoteService,
      router,
      route,
      confirmation,
      localizationService,
      subscriptionService,
      datasource,
      injector,
    );
  }

  duplicateSupplierQuote() {
    this.supplierQuoteService
      .getAnnexesCount(this.selectedEntities()[0].id)
      .subscribeOnce(count => {
        this.duplicateDoc(count != 0);
      });
  }
}
